<template>
  <ul class="list">
    <li v-for="tag in withChildrenTags" :key="tag.id" class="list__item item">
      <label class="label">
        <input
          type="radio"
          name="editing-tag"
          class="label__input"
          :checked="selectedTagId === tag.id"
          @input="$emit('selectTag', tag.id)"
        />
        <p class="label__name tag">{{ tag.name }}</p>
      </label>
      <TagCreateForm
        v-if="getShouldShowCreateForm(tag)"
        tagType="category"
        :parentId="tag.id"
        :placeholder="`${tag.name}の下に新規カテゴリを作成`"
        class="item__form"
        @createTag="createTag"
      />
      <TagList
        :selectedTagId="selectedTagId"
        :tags="tag.children"
        :allTags="allTags"
        class="item__children"
        @selectTag="$emit('selectTag', $event)"
        @createTag="createTag"
      />
    </li>
  </ul>
</template>

<script>
import TagCreateForm from '../TagCreateForm/TagCreateForm.vue';
import { getAncestorTagsLength } from '../../../libs/tags';

export default {
  name: 'TagList',
  components: {
    TagCreateForm,
  },
  props: {
    selectedTagId: {
      type: Number,
      default: null,
    },
    // その階層だけのタグの配列
    tags: {
      type: Array,
      default: () => [],
    },
    // 全体のタグの配列
    allTags: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    withChildrenTags() {
      return this.tags.map((tag) => {
        return {
          ...tag,
          children: this.allTags.filter(
            (childTag) => childTag.parent_id === tag.id
          ),
        };
      });
    },
  },
  methods: {
    getShouldShowCreateForm(tag) {
      return (
        this.selectedTagId === tag.id &&
        (tag.tag_type === 'category' || tag.tag_type === 'subcategory') &&
        getAncestorTagsLength(this.allTags, tag.id) < 3
      );
    },
    createTag(tag) {
      this.$emit('createTag', tag);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  font-size: 12px;

  &__item {
    line-height: 16px;

    &::marker {
      transform: translateY(-2px);
    }

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.item {
  &__form {
    &:nth-child(n + 2) {
      margin-top: 8px;
      margin-left: 25px;
    }
  }

  &__children {
    margin-left: 24px;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}

.label {
  $root: &;
  display: inline-flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  &__input {
    flex: 0 0 auto;
    margin: 0;
    appearance: checkbox;
  }

  &__name {
    flex: 0 0 auto;
    transition: filter 200ms;

    @at-root #{$root}:hover & {
      filter: brightness(0.8);
    }

    &:nth-child(n + 2) {
      margin-left: 12px;
    }
  }
}

.tag {
  padding: 4px 6px;
  background-color: #eee;
  color: #333;
  border-radius: 4px;
}
</style>
